import { useCurrentUser } from '../../contexts/UserContext';
import StudentDashboard from './StudentDashboard';
import TeacherDashboard from './TeacherDashboard';

export default function DashboardPage() {
  const currentUser = useCurrentUser();
  const isStudent = currentUser?.role === 'student';
  return isStudent ? <StudentDashboard /> : <TeacherDashboard />;
}
